














import { VueCustom } from 'vue-custom';
import { delay } from 'utils';
import EventsManager from 'managers/events.manager';

const ANIMATION_DURATION = 500;

export default VueCustom.extend({
  name: 'menu-button',
  props: {
    active: {
      type: Boolean,
      required: false,
      default: true,
    },
    primaryText: {
      type: String,
      required: true,
    },
    secondaryText: {
      type: String,
      required: false,
      default: '',
    },
    alwaysShow: {
      type: Boolean,
      required: false,
      default: false,
    },
    alwaysAnimate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    animating: false,
  }),
  computed: {
    classes(): Record<string, boolean> {
      const jsIn = this.alwaysAnimate ? this.animating : this.isPrimary;

      return {
        primary: this.isPrimary || (this.alwaysAnimate && this.animating),
        secondary: !this.active && this.hasSecondary && (!this.alwaysAnimate || !this.animating),
        back: !this.alwaysShow && this.hasSecondary,
        'js-in': jsIn,
      };
    },
    isPrimary(): boolean {
      return this.active || !this.hasSecondary;
    },
    hasSecondary(): boolean {
      return !!this.secondaryText.length;
    },
  },
  methods: {
    onClick() {
      this.click();
      this.handleAnimation();
    },
    click() {
      this.$emit('click');
      this.emitSound();
    },
    async handleAnimation() {
      if (!this.alwaysAnimate) return;

      this.animating = true;

      // cannot listen for animationend or transition end because of multiple events being called
      await delay(ANIMATION_DURATION);
      this.onAnimationEnd();
    },
    onAnimationEnd() {
      this.animating = false;
    },
    emitSound() {
      EventsManager.emit('BUTTON_CLICK');
    },
  },
});
